import { render, staticRenderFns } from "./task-confirmation-dialog.vue?vue&type=template&id=50adbbde&scoped=true"
import script from "./task-confirmation-dialog.vue?vue&type=script&lang=js"
export * from "./task-confirmation-dialog.vue?vue&type=script&lang=js"
import style0 from "./task-confirmation-dialog.vue?vue&type=style&index=0&id=50adbbde&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50adbbde",
  null
  
)

export default component.exports